<template lang="pug">
  .channel-manager-settings.text-left.p-4
    b-row.no-gutters
      b-col.position-relative(sm="12")
        h3.text-center Channex Integration
        b-button.btn-sync(variant="outline-secondary" @click="showSyncModal = true")
          i.fi-refresh
          span.ml-1 Sync

    b-row.mt-3(v-for="unitType in unitTypes" :key="unitType.id")
      b-col(sm="12")
        p.font-weight-bold.mb-0 {{ unitType.unit_type_name }} ({{ unitType.unit_type_description }})
        hr.mt-0

      b-col(v-for="unit in unitType.unit" :key="unit.id" sm="12")
        b-row.align-items-center.mb-2
          b-col(sm="6") {{ unit.unit_name }} ({{ unit.unit_description }}, occ: {{ unit.default_occupancy }})

          b-col.d-flex.align-items-center(sm="6")
            toggle-button.active-toggle.mr-5(
              :value="!!unit.channex_connected"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              :width="80"
              :height="33"
              :sync="true"
              style="font-size: 16px;"
              color="#82C7EB"
              @change="(v) => onToggleConnect(unit, v)"
            )

            b-form-select.form-control(
              v-model="unit.channex_room_id"
              value-field="id"
              text-field="title"
              :options="channexRoomTypeOptions"
              :disabled="!unit.channex_connected"
              @change="(e) => onSelectRoomType(unit, e)"
            )

    sync-main-modal(
      v-model="showSyncModal"
      @import-bookings="onImportBookings"
      @sync-units="onSendUnits"
      @sync-rates="showSyncRatesModal = true"
      @sync-avr="showSyncAvrModal = true"
    )

    sync-rates-modal(
      v-model="showSyncRatesModal"
      @sync="onSyncRates"
    )

    sync-availability-modal(
      v-model="showSyncAvrModal"
      @sync="onSyncAvailability"
    )

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ApiBase from '@/utils/api-base';
import API from '@/api';

export default {
  name: 'ChannelManager',

  components: {
    SyncMainModal: () => import('@/components/modals/SyncMainModal'),
    SyncRatesModal: () => import('@/components/modals/SyncRatesModal'),
    SyncAvailabilityModal: () => import('@/components/modals/SyncAvailabilityModal'),
  },

  computed: {
    ...mapGetters([
      'getUnitTypesList',
      'channexRoomTypes'
    ]),

    channexRoomTypeOptions () {
      const firstItem = {
        id: -1,
        title: 'Create New...'
      }

      return [
        firstItem,
        ...this.channexRoomTypes
      ];
    }
  },

  mounted() {
    // this.getDiscountCodes()
    this.getChannexRoomTypes();
    this.initUnitTypes();
  },

  data: () => ({
    unitTypes: [],
    showSyncModal: false,
    showSyncRatesModal: false,
    showSyncAvrModal: false,
  }),

  methods: {
    ...mapActions([
      'successNotification',
      'errorNotification',
      'fetchAccommodations',
      'getChannexRoomTypes',
      'setShowLoadingOverlay',
      'setLoadingMessage',
    ]),

    initUnitTypes () {
      this.unitTypes = JSON.parse(JSON.stringify(this.getUnitTypesList));
    },

    handleConnect (unit_id, room_id, is_connect = true) {
      const requestUri = is_connect === true
        ? API.CHANNEX_CONNECT_ROOM
        : API.CHANNEX_DISCONNECT_ROOM;

      const params = {
        id: unit_id
      };

      if (is_connect && room_id) {
        params.room_id = room_id;
      }

      this.setShowLoadingOverlay(true)

      ApiBase.post(requestUri, params)
        .then(() => {
          return this.fetchAccommodations()
        })
        .then(() => {
          if (!room_id) {
            return this.getChannexRoomTypes()
          }
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to register room type in Channex.');
          this.unitTypes = [];
          this.$nextTick(() => {
            this.initUnitTypes();
          })
        })
        .finally(() => {
          this.setShowLoadingOverlay(false)
        })
    },

    onToggleConnect (unit, e) {
      console.log(unit, e);
      // this.handleConnect(unit.id, unit.channex_room_id, e.value);
      const params = {
        channex_connected: e.value
      };

      ApiBase.put(`${API.UNIT}/${unit.id}`, params)
        .then(() => {
          return this.fetchAccommodations()
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to toggle connect.');
        })
        .finally(() => {

        });
    },

    onSelectRoomType (unit, e) {
      console.log(e);
      if (e === -1) {
        this.handleConnect(unit.id, null, true);
      } else {
        this.handleConnect(unit.id, e);
      }
    },

    onSendUnits () {
      this.setShowLoadingOverlay(true)

      ApiBase.post(API.CHANNEX_SYNC_ALL_UNITS)
        .then(() => {
          this.successNotification('Units sent to Channex successfully.');
          this.$store.dispatch('fetchAccommodations');
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to send units to Channex.');
        })
        .finally(() => {
          this.setShowLoadingOverlay(false)
        });
    },

    onSyncRates (data) {
      console.log('sync rates: ', data);

      this.setShowLoadingOverlay(true)

      ApiBase.post(API.CHANNEX_SYNC_ALL_RATES, data)
        .then(() => {
          this.successNotification('Rates sent to Channex successfully.');
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to send rates to Channex.');
        })
        .finally(() => {
          this.showSyncRatesModal = false;
          this.setShowLoadingOverlay(false)
        });
    },

    onSyncAvailability (data) {
      console.log(data);
    },

    onImportBookings () {
      this.setShowLoadingOverlay(true)

      ApiBase.post(API.CHANNEX_IMPORT_BOOKINGS)
        .then(() => {
          this.successNotification('Channex bookings imported successfully.');
          this.$store.dispatch('fetchBookings');
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to import bookings from Channex.');
        })
        .finally(() => {
          this.setShowLoadingOverlay(false)
        });
    }
  },

  watch: {
    getUnitTypesList () {
      console.log('unit types updated');
      this.$nextTick(() => {
        this.initUnitTypes();
      })
    }
  }
};
</script>

<style lang="scss">
.btn-sync {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 1;
}

.channex-sync {
  padding: 15px;
}
</style>
